<template>
  <div>
    <a-card
      style="width:100%"
      title="Reenganche"
    >
      <p>Empleado seleccionado: {{empleadoseleccionado}}</p>
      <br>
      <a-button :disabled="isValid" @click="modal.visible = true" type="primary" icon="reload">
        Reenganche
      </a-button>
    </a-card>
    <a-modal title="Solicitud"
             :visible="modal.visible"
             @ok="confirmar"
             :confirmLoading="modal.loading"
             @cancel="modal.visible = false"
             style="top: 20px;">
      <span>¿Está seguro de reenganchar el empleado seleccionado?</span>
      <br/>
    </a-modal>
  </div>
</template>

<script>
  import HttpUtil from '@/util/HttpUtil'
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'
  import JsUtils from '../../../../util/JsUtils'

  export default {
    data () {
      return {
        modal: {
          visible: false,
          loading: false
        }
      }
    },
    props: ['empleadoseleccionado'],
    mounted () {
      this.httpClient = new HttpUtil()
    },
    methods: {
      confirmar () {
        this.modal.loading = true
        this.httpClient.getInstance().post('employee/reenganche', {
          id_emp: this.empleadoseleccionado
        })
          .then(response => {
            this.$emit('loadData')
            this.modal.loading = false
            this.modal.visible = false
            Mensajes.info('Información', response.data.VCERROR)
          })
          .catch(() => {
            this.modal.loading = false
            Mensajes.error('Error', 'Contacte a un administrador')
          })
          .then(() => {
            this.modal.loading = false
          })
      }
    },
    computed: {
      isValid () {
        if (!JsUtils.isEmpty(this.empleadoseleccionado)) {
          if (this.empleadoseleccionado.includes('-')) {
            return true
          } else {
            return false
          }
        } else {
          return true
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Empleados/EmployeeReenganche.vue